<template>
  <div class="recepty">
    <div v-if="typeof recept!== 'undefined'">
      <h1>{{recept.nazev}}</h1>
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <span
              style="font-size:100%;"
              v-bind:key="stitek"
              v-for="(stitek) in recept.stitky"
              class="stitek badge badge-success"
            >{{stitek}}</span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="bv-example-row">
        <div class="row">
          <div class="col-sm">
            <div class="row">
              <div class="col-sm" style="margin: 11px">
                <b-list-group>
                  <b-list-group-item
                    v-bind:key="surovina"
                    v-for="surovina in recept.suroviny"
                  >{{surovina}} <b-button @click="addToSeznam(surovina)">+</b-button></b-list-group-item>
                </b-list-group>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <b-list-group>
                  <b-list-group-item>
                    <b>Doba přípravy:</b>
                    {{recept.doba}}
                  </b-list-group-item>
                  <b-list-group-item>
                    <b>Pro:</b>
                    {{recept.porce}} lidí
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>
          <div class="col-sm">
            <b-img style="margin: 10px" :src="recept.obrazek" fluid></b-img>
          </div>
          <div class="col-sm" style="margin: 10px">
            <b-list-group>
              <b-list-group-item v-bind:key="koren" v-for="koren in recept.koreni">{{koren}}</b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </b-container>
      <h3>Recept</h3>
      <span style="text-align: left" v-html="recept.recept"></span>
      <div v-if="parseInt($route.params.id) && recepty">
        <comment-section :recept="recept"></comment-section>
      </div>
    </div>
  </div>
</template>

<script>
import commentSection from "./components/commentSection.vue";
export default {
  name: "Recept",
  props: {
    recepty: Array
  },
  components: {
    commentSection
  },
  data: () => {
    return {
      id: null,
      errors: [],
      recept: {
        nazev: "",
        suroviny: [],
        stitky: [],
        porce: "",
        doba: "",
        id: 0,
        obrazek: ""
      },
      ahoj: "dick",
      errors: []
    };
  },
  methods: {
    setId(id) {
      if (this.recepty.length !== 0) {
        //alert(this.$route.params.id);
        this.id = parseInt(id);
        this.recept = this.recepty[id];
      }
    },
    addToSeznam(payload){
      this.$store.commit("addToSeznam", payload);
    }
  },
  updated() {
    console.log("updated");
    this.setId(this.$route.params.id);
  },
  mounted() {
    console.log("mounted");
    this.setId(this.$route.params.id);
  },
  beforeResolve(to, from, next) {
    console.log("beforeresolve");
    this.setId(to.params.id);
  },

  
};
</script>

<style scoped>
.odsun {
  margin-top: 12px;
}

.stitek {
  margin-bottom: 0px;
  margin-right: 5px;
}
</style>